import { createContext, useContext } from "react";

/** The working-area status bar slot, plus the pane whose bottom bar fills it. */
export type StatusBarPortal = {
  slot: HTMLElement | null;
  primaryPaneId: string | null;
};

export const StatusBarPortalContext = createContext<StatusBarPortal>({ slot: null, primaryPaneId: null });

export const useStatusBarPortal = () => useContext(StatusBarPortalContext);
